<script lang="ts">
  import { onMount } from 'svelte';
  import { reveal } from 'svelte-reveal';
  export let src: string;
  export let alt: string;
  export let caption: string;
</script>

<div class="w-full mb-16 pt-4 md:pt-8 mb-8 md:mb-16" use:reveal={{ scale: 0.9 }}>
  <div class="w-full overflow-hidden lg:px-8">
    <img 
      src={src} 
      alt={alt} 
      class="w-full h-auto object-cover"
    />
  </div>
  {#if caption}
    <div class="caption-block">
      <p class="caption-text">{caption}</p>
    </div>
  {/if}
</div>

<style>
  img {
    will-change: transform;
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .caption-block {
    margin-top: 2rem;
    padding: 0.5rem 0;
    border-top: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
    text-align: center;
    width: 70%;
    margin-left: auto;
    margin-right: auto;
  }
  .caption-text {
    color: #6b7280;
    font-size: 1rem;
    margin: 0.5rem auto;
    font-weight: 400;
    max-width: 70%;
    width: 100%;
    text-align: left;
  }
</style> 